import React from 'react';

export const SupportPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-12">
          <a
            href="https://enter.health"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            ← enter.health
          </a>
        </div>

        <h1 className="text-3xl font-bold mb-2">Support</h1>
        <p className="text-sm text-muted-foreground mb-12">We're here to help.</p>

        <div className="space-y-10 text-sm leading-relaxed">
          <section>
            <h2 className="text-base font-semibold mb-4">Contact Us</h2>
            <div className="border border-border rounded p-5 space-y-1">
              <p className="text-muted-foreground">For all support inquiries, email us at:</p>
              <a
                href="mailto:support@enter.health"
                className="text-foreground font-medium underline underline-offset-2"
              >
                support@enter.health
              </a>
              <p className="text-muted-foreground pt-2">
                We typically respond within one business day.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-4">Frequently Asked Questions</h2>
            <div className="space-y-6">
              <div>
                <p className="font-medium mb-1">How do I install the Chrome extension?</p>
                <p className="text-muted-foreground">
                  Install Enter Control from the Chrome Web Store. Once installed, you'll see the
                  Enter Control icon in your browser toolbar. Press{' '}
                  <kbd className="px-1.5 py-0.5 bg-muted border border-border rounded text-xs">
                    Ctrl+Shift+E
                  </kbd>{' '}
                  (or{' '}
                  <kbd className="px-1.5 py-0.5 bg-muted border border-border rounded text-xs">
                    Cmd+Shift+E
                  </kbd>{' '}
                  on Mac) to open the assistant on any page.
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">Do I need an account?</p>
                <p className="text-muted-foreground">
                  Yes. An Enter Control account is required to use the assistant. Sign up or sign in
                  at{' '}
                  <a
                    href="https://enter.health"
                    className="text-foreground underline underline-offset-2"
                  >
                    enter.health
                  </a>
                  . Enterprise customers can sign in via SSO.
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">What subscription plans are available?</p>
                <p className="text-muted-foreground">
                  We offer individual and team plans. Pricing details are available at{' '}
                  <a
                    href="https://enter.health"
                    className="text-foreground underline underline-offset-2"
                  >
                    enter.health
                  </a>
                  . Contact us for enterprise pricing.
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">Does Enter Control work on any website?</p>
                <p className="text-muted-foreground">
                  Yes. The side panel and keyboard shortcut work on any page in Chrome. The AI
                  assistant can reference content from the page you're currently viewing when you
                  ask it to.
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">Is my microphone always on?</p>
                <p className="text-muted-foreground">
                  No. The microphone is only active when you explicitly press the voice recorder
                  button. Audio is streamed to our transcription service only during active
                  recording and is never stored.
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">Is Enter Control HIPAA compliant?</p>
                <p className="text-muted-foreground">
                  We offer a Business Associate Agreement (BAA) for enterprise customers subject to
                  HIPAA. Contact us at{' '}
                  <a
                    href="mailto:privacy@enter.health"
                    className="text-foreground underline underline-offset-2"
                  >
                    privacy@enter.health
                  </a>{' '}
                  to request a BAA.
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">How do I cancel my subscription?</p>
                <p className="text-muted-foreground">
                  You can manage or cancel your subscription from the billing settings inside the
                  app. If you need help, email{' '}
                  <a
                    href="mailto:support@enter.health"
                    className="text-foreground underline underline-offset-2"
                  >
                    support@enter.health
                  </a>
                  .
                </p>
              </div>

              <div>
                <p className="font-medium mb-1">How do I report a bug?</p>
                <p className="text-muted-foreground">
                  Use the feedback button inside the app, or email{' '}
                  <a
                    href="mailto:support@enter.health"
                    className="text-foreground underline underline-offset-2"
                  >
                    support@enter.health
                  </a>{' '}
                  with a description of the issue, your browser version, and steps to reproduce.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-3">Privacy</h2>
            <p className="text-muted-foreground">
              Read our{' '}
              <a href="/privacy" className="text-foreground underline underline-offset-2">
                Privacy Policy
              </a>{' '}
              to understand how we handle your data.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
